<template>
  <div id="app" class="letmesee" :class="{'is-mobile': isMobile}">
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'App',
  computed: {
    ...mapGetters([
      'platform'
    ]),
    isMobile() {
      return this.platform.isAndroid || this.platform.isIos
    }
  }
}
</script>

<style lang="less">
  @import url("~@/styles/var.less");
  @import url("~@/styles/font.less");
  @import url("~@/styles/normalize.less");

  @media (prefers-color-scheme: dark) {
    @import url("~@/styles/dark.less");
  }

  .letmesee {
    font-family: 'Open Sans';
    &.is-mobile {
      .layout {
        padding-bottom: 100px;
      }
    }
  }
  * {
    box-sizing: border-box;
  }

  button,
  input[type="button"] {
    outline: none;
    border: none;
    margin: 0;
    padding: 0;
    cursor: pointer;
    background-color: transparent;
  }

  .flex {
    display: flex;
    align-items: center;
  }
  .flex-start {
    justify-content: flex-start;
  }
  .flex-end {
    justify-content: flex-end;
  }
  .flex-between {
    justify-content: space-between;
  }
  .flex-center {
    justify-content: center;
  }
  .inline-flex {
    display: inline-flex;
  }
  .inline-block {
    display: inline-block;
  }

  .hidden {
    display: none;
  }

  .scrollbar {
    overflow: auto;
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 6px;
      background: var(--background-contrl, rgba(144, 147, 153, 0.65));
    }
  }
</style>
